type UserWithoutName = {
  email?: string
  firstName: string
  lastName: string
}

type UserWithName = {
  name: string
  email?: string
}

export const getLabelForUser = (user: UserWithoutName | UserWithName) => {
  const name = 'firstName' in user ? `${user.firstName} ${user.lastName}` : user.name
  if (user.email) {
    return `${name} [${user.email}]`
  }
  return name
}
